var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBooking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 40585"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 40578"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47299",
    d: "M-965.485 268.7h17.106a2.806 2.806 0 0 1 3.08 3.071v3.818a1.232 1.232 0 0 1-.92 1.355A4.3 4.3 0 0 0-949.1 281a4.3 4.3 0 0 0 2.876 4.056 1.23 1.23 0 0 1 .921 1.354c0 1.339.007 2.678 0 4.016a2.769 2.769 0 0 1-2.878 2.874q-17.354.006-34.71 0a2.77 2.77 0 0 1-2.883-2.87c-.007-1.207 0-2.413 0-3.62 0-.992.4-1.4 1.4-1.451a4.359 4.359 0 0 0 3.833-6.287 4.379 4.379 0 0 0-3.783-2.424c-1.073-.081-1.452-.448-1.453-1.506 0-1.19-.006-2.38 0-3.57a2.768 2.768 0 0 1 2.881-2.87q8.708-.01 17.411-.002zm-2.03 2.381v19.811a.7.7 0 0 0 .119.026q9.571 0 19.143.008c.434 0 .583-.2.578-.606-.013-.975.011-1.952-.018-2.926a.732.732 0 0 0-.3-.524 6.5 6.5 0 0 1-3.469-5.843 6.5 6.5 0 0 1 3.47-5.892.738.738 0 0 0 .3-.525c.03-.925.014-1.851.013-2.777 0-.7-.048-.751-.772-.751h-19.063zm-2.377 0h-12.72c-.116 0-.258-.041-.342.011-.162.1-.41.249-.416.386-.036.952-.019 1.906-.019 2.849a6.865 6.865 0 0 1 5.706 6.615 6.435 6.435 0 0 1-1.18 3.82 7.025 7.025 0 0 1-4.53 2.9v2.5c0 .707.053.76.763.76h12.737z",
    transform: "translate(995.296 -252.825)",
    style: {
      fill: "#faa258"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47300",
    d: "M-971.135 254.4a26.244 26.244 0 0 1-.145 2.779 4.248 4.248 0 0 1-4.113 3.558q-3.321.051-6.645 0a4.339 4.339 0 0 1-4.214-4.237c-.016-.676 0-1.352 0-2.069-.167-.011-.308-.03-.45-.03h-4.562a1.989 1.989 0 0 0-2.131 2.141v40.964a1.987 1.987 0 0 0 2.144 2.129h25.094a1.987 1.987 0 0 0 2.124-2.1c0-.48-.01-.959 0-1.439a1.193 1.193 0 0 1 1.177-1.218 1.179 1.179 0 0 1 1.193 1.2 13.7 13.7 0 0 1-.043 2.129 4.316 4.316 0 0 1-4.412 3.81c-3.571.009-7.141 0-10.712 0h-14.282a4.378 4.378 0 0 1-4.668-4.642v-40.716a4.371 4.371 0 0 1 4.622-4.637h24.9a4.368 4.368 0 0 1 4.605 4.6v7.587a1.208 1.208 0 0 1-.679 1.174 1.106 1.106 0 0 1-1.215-.118 1.289 1.289 0 0 1-.491-1.132c.008-2.463 0-4.927 0-7.389a2.044 2.044 0 0 0-2.325-2.346zm-2.429.036h-10.312v1.717c0 .131 0 .265.008.4a1.955 1.955 0 0 0 1.9 1.811q3.247.033 6.5 0a1.935 1.935 0 0 0 1.9-1.859c.029-.683.004-1.36.004-2.072z",
    style: {
      fill: "#faa258"
    },
    transform: "translate(995.781 -252.016)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47301",
    d: "M-958.047 275.369h3.02a1.209 1.209 0 0 1 1.333 1.208 1.2 1.2 0 0 1-1.323 1.168q-3.044.009-6.089 0a1.2 1.2 0 0 1-1.309-1.184 1.2 1.2 0 0 1 1.3-1.192c1.023-.006 2.046 0 3.068 0z",
    transform: "translate(994.163 -253.148)",
    style: {
      fill: "#faa258"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47302",
    d: "M-958.055 280.373h2.971c.85 0 1.4.481 1.391 1.2a1.215 1.215 0 0 1-1.365 1.178q-2.994.006-5.99 0a1.216 1.216 0 0 1-1.367-1.176c-.009-.722.539-1.2 1.39-1.2.99-.004 1.98-.002 2.97-.002z",
    transform: "translate(994.163 -253.391)",
    style: {
      fill: "#faa258"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47303",
    d: "M-958.091 287.759h-2.971a1.214 1.214 0 0 1-1.353-1.189 1.213 1.213 0 0 1 1.355-1.188q3.019-.006 6.039 0a1.206 1.206 0 0 1 1.327 1.164 1.208 1.208 0 0 1-1.329 1.213c-1.023.004-2.045 0-3.068 0z",
    transform: "translate(994.163 -253.633)",
    style: {
      fill: "#faa258"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3445",
    style: {
      fill: "none"
    },
    d: "M0 0h50v50H0z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/Booking.56ff801c2aec077ce463aac9b45489fd.svg";
export { ForwardRef as ReactComponent };